import * as React from 'react';
declare const I18n;

type Props = {
  value: (string | number)[]; // multiple values
  error?: string;
  type: string;
  field: string;
  label: string;
  className?: string;
  columnSize: number;
  style?: React.CSSProperties;
  onChange(values: (string | number)[]): void;
  children: React.ReactNode;
};

const MultiSelectInput: React.FunctionComponent<Props> = ({
  value,
  error,
  type,
  field,
  label,
  className,
  columnSize,
  onChange,
  style,
  children,
}: Props): JSX.Element => (
  <div className={`col-md-${columnSize}`} style={style}>
    <div className="form-group">
      <label className={`${className} d-block`} htmlFor={`${type}_${field}`}>
        {label}
      </label>
      <select
        multiple
        className={`form-control ${error ? 'is-invalid' : ''}`}
        id={`${type}_${field}_id`}
        name={`${type}[${field}][]`}
        value={value.map(String)}
        onChange={(event) => {
          const selectedValues = Array.from(event.target.selectedOptions, (option) =>
            isNaN(Number(option.value)) ? option.value : Number(option.value)
          );
          onChange(selectedValues);
        }}
      >
        {children}
      </select>
      <small className="form-text text-muted" style={{ fontSize: "12px" }}>
        {I18n.t("common.multiselect-tip")}
      </small>
      {error && <div className="invalid-feedback d-block">{error}</div>}
    </div>
  </div>
);

export default MultiSelectInput;
